module.exports = __webpack_public_path__ + "img/sales_icon_pink.09560457.svg";